import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  const handleDecouvrir = (e) => {
    e.preventDefault();
    const el = document.getElementById("modules");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="mk-hero" id="top" data-testid="section-hero">
      <div className="mk-wrap mk-hero-grid">
        <div className="mk-hero-copy mk-reveal">
          <span className="mk-eyebrow">
            <span className="mk-pulse" aria-hidden="true" />
            Plateforme IA pour ESN & cabinets de conseil
          </span>
          <h1 className="mk-hero-title" data-testid="hero-title">
            Pilotez<br />votre société<br />à la vitesse de l'IA
          </h1>
          <p className="mk-lead">
            ASAP Hub centralise tous vos outils dans une même plateforme. Trouvez rapidement les meilleurs candidats, consolidez vos données et prenez les meilleures décisions.
          </p>
          <div className="mk-hero-actions">
            <Link to="/contact" className="mk-btn mk-btn-primary" data-testid="hero-cta-demo">
              Demander une démo
            </Link>
            <a href="#modules" onClick={handleDecouvrir} className="mk-btn mk-btn-ghost" data-testid="hero-cta-decouvrir">
              Découvrir
            </a>
          </div>
        </div>

        <div className="mk-hero-lab mk-reveal" aria-label="Aperçu produit ASAP Hub">
          <div className="mk-hero-device">
            <div className="mk-browser">
              <div className="mk-lights"><span /><span /><span /></div>
              <span>www.asap-hub.ai</span>
            </div>
            <div className="mk-candidate-card">
              <div className="mk-candidate-head">
                <div className="mk-profile-icon" aria-hidden="true">DM</div>
                <div className="mk-profile-meta">
                  <b>Dupont Martin</b>
                  <span>Profil expert technique en Python BFI</span>
                </div>
              </div>
              <div className="mk-hero-list">
                <section className="mk-hero-line">
                  <div className="mk-hero-line-icon">SK</div>
                  <div>
                    <h3>Évaluation des compétences</h3>
                    <div className="mk-bar-row">
                      <span>Python</span>
                      <span className="mk-bar"><i style={{ width: "87%" }} /></span>
                      <span>87%</span>
                    </div>
                    <div className="mk-bar-row">
                      <span>GCP</span>
                      <span className="mk-bar"><i style={{ width: "75%" }} /></span>
                      <span>75%</span>
                    </div>
                    <div className="mk-bar-row">
                      <span>Asset Mgmt</span>
                      <span className="mk-bar"><i style={{ width: "69%" }} /></span>
                      <span>69%</span>
                    </div>
                  </div>
                </section>
                <section className="mk-hero-line">
                  <div className="mk-hero-line-icon mk-score-circle">93%</div>
                  <div>
                    <h3>Matching à 93% avec le besoin Tech leads en asset</h3>
                  </div>
                </section>
                <section className="mk-hero-line">
                  <div className="mk-hero-line-icon">SR</div>
                  <div>
                    <h3>ASAP Profile</h3>
                    <div className="mk-search-item">
                      <div><b>Sophie Martin</b><br /><small>Frontend Engineer · React / Vue</small></div>
                      <span className="mk-pct">91%</span>
                    </div>
                    <div className="mk-search-item">
                      <div><b>Yanis Bernard</b><br /><small>Développeur UI · Next.js / TS</small></div>
                      <span className="mk-pct">88%</span>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
